import styled from 'styled-components';
import { grey30, grey200, brandColors } from 'styles/colors';
import noDataImage from 'assets/images/nodata.png';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	background-color: ${grey30};
	display: flex;
	flex-direction: column;
	align-items: center;
	min-height: 100%;
`;

export const LoadingContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const ImageContainer = styled.div`
	margin-top: 22px;
	background-image: url(${noDataImage});
	background-repeat: no-repeat;
	background-size: contain;
	min-height: 372px;
	min-width: 372px;
`;

export const TextContainer = styled.div`
	max-width: 625px;
	margin-top: -38px;
`;

export const Title = styled.div`
	color: ${colors.grey8};
	margin-bottom: 24px;
	font-weight: 500;
	font-size: 33px;
	line-height: 41px;
	text-align: center;
	letter-spacing: 0.3px;
`;

export const Text = styled.div`
	color: ${colors.grey5};
	letter-spacing: 0;
	font-weight: normal;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
`;

export const Help = styled.div`
	margin-top: 101px;
	text-align: center;
	margin-bottom: 24px;
`;

export const Link = styled.a`
	color: ${brandColors.green};
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 19px;
`;

export const Actions = styled.div`
	display: flex;
	align-items: center;
	margin: 50px 0 32px 0;
	justify-content: center;
`;

export const ActionSection = styled.div`
	display: flex;
	align-items: center;
	padding: 13px 20px;

	&:not(:first-child) {
		border-left: 1px solid ${grey200};
	}
`;
